import { ViewEditMode } from '@shared/components/most-used/view-edit-switch/view-edit-switch.component';
import { AppModes } from '@shared/services/app.service';
import { ICurrentCompanyType } from '@shared/services/current-user.service';
import { Observable, Subject } from 'rxjs';

export interface ICompany {
  type: keyof ICurrentCompanyType;
  id: number;
}

export type CompanyType = 'PRODUCER' | 'DISTRIBUTOR' | 'CLIENT';

export abstract class ViewEditableComponentAbstract {
  abstract mode$: Observable<ViewEditMode>;
}

export interface IClickablePanel {
  childClick$: Subject<string>;
}

export interface ITypeWithId {
  id: number | string;
}

export enum DirectionTypes {
  incoming = 'incoming',
  outgoing = 'outgoing'
}

export interface IActionProp {
  actions: string;
}

export interface ITableColumn<T> {
  propName: string;
  title?: string;
  enabledSortOrder?: 'ASC' | 'DESC';
  hideIfMode?: AppModes[];
  sortType?: T;
  showIf?: string[];
  sizes?: ITableColumnSizes;
}

export interface ITableColumnExtended<T, ShowHideCond> {
  propName: string;
  title?: string;
  enabledSortOrder?: 'ASC' | 'DESC';
  hideIfMode?: AppModes[];
  hideIf?: ShowHideCond[];
  sortType?: T;
  showIf?: ShowHideCond[];
  sizes?: ITableColumnSizes;
}

export interface ITableColumnSizes {
  width: number;
  minWidth?: number;
  fixedSize?: boolean;
}

export type TableColumns<Model, Sorting>
  = {[key in keyof Model]: ITableColumn<Sorting>}

export type TableColumnsExt<Model, Sorting, ShowIf>
  = {[key in keyof Model]: ITableColumnExtended<Sorting, ShowIf>}
